export default __webpack_public_path__ + "static/media/sport-objects.spritesheet@1x.99f9dab3.png";